module.exports = Em.View.extend({
    classNames: ['password-reset-view', 'prelogin-view'],

    focusFirst: function() {
        var field = this.$('input[name="password"]')
        field.val('')
        field.focus()
    }.on('didInsertElement')
})
